// extracted by mini-css-extract-plugin
export default {"lds_roller":"Loader_lds_roller__ePfNP"};